var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iv-footer"},[_c('div',{staticClass:"container-fluid text-right"},[_c('p',{staticClass:"iv-footer-text"},[_vm._v(" Powered by "),_c('a',{attrs:{"href":_vm.env.serverAddr}},[_c('img',{staticClass:"iv-logo",attrs:{"src":_vm.env.staticAddr + '/ivgcs/img/logo-original.png',"alt":"InitialView"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }